import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import { BeatLoader } from 'react-spinners';
import { FiCheckCircle, FiAlertCircle, FiSave } from 'react-icons/fi';

const QuotationSettings = () => {
  const [settings, setSettings] = useState({
    installation_charge: '',
    panel_cost_per_kwp: '',
    investor_cost: '',
    wiring_charge: '',
    meter_cost: '',
    labour_cost: '',
    misc_charge: '',
    GST_rate: '',
    electricity_rate: '',
    expected_units_per_kwp_per_day: '',
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get("https://3esolarventures.com/backend/getQuotationRates.php");
        if (response.data.success && response.data.settings) {
          setSettings(response.data.settings);
        } else {
          setError(response.data.error || 'No settings found.');
        }
      } catch (err) {
        console.error("Error fetching settings:", err);
        setError('Failed to load settings. Please try again later.');
      }
      setLoading(false);
    };

    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    console.log(settings);
    try {
      const response = await axios.post(
        "https://3esolarventures.com/backend/updateQuotationRates.php",
        settings,
        { headers: { 'Content-Type': 'application/json' } }
      );
      
      if (response.data.success) {
        setMessage('Settings updated successfully!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setError(response.data.error || 'Update failed. Please check your values.');
      }
    } catch (err) {
      console.error("Error updating settings:", err);
      setError('Connection error. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center p-8">

      </div>
    );
  }

  return (
    <div className="max-w-full mx-auto p-6 bg-white rounded-xl shadow-sm">
      <h1 className="text-2xl font-semibold text-gray-800 mb-8 pb-4 border-b border-gray-200">
        Quotation Configuration
      </h1>

      {/* Alerts */}
      {message && (
        <div className="flex items-center gap-3 mb-6 p-4 bg-green-50 text-green-700 rounded-lg border border-green-200">
          <FiCheckCircle className="w-5 h-5 flex-shrink-0" />
          <span>{message}</span>
        </div>
      )}
      
      {error && (
        <div className="flex items-center gap-3 mb-6 p-4 bg-red-50 text-red-700 rounded-lg border border-red-200">
          <FiAlertCircle className="w-5 h-5 flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Installation Charge */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Installation Charge</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <span className="absolute right-3 text-gray-500">₹</span>
              <input
                type="number"
                name="installation_charge"
                value={settings.installation_charge}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
            </div>
          </div>

          {/* Panel Cost */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Panel Cost (per KWp)</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <span className="absolute right-3 text-gray-500">₹</span>
              <input
                type="number"
                name="panel_cost_per_kwp"
                value={settings.panel_cost_per_kwp}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
            </div>
          </div>

          {/* Investor Cost */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Investor Cost</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <span className="absolute right-3 text-gray-500">₹</span>
              <input
                type="number"
                name="investor_cost"
                value={settings.investor_cost}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
            </div>
          </div>

          {/* Wiring Charge */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Wiring Charge</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <span className="absolute right-3 text-gray-500">₹</span>
              <input
                type="number"
                name="wiring_charge"
                value={settings.wiring_charge}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
            </div>
          </div>

          {/* Meter Cost */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Meter Cost</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <span className="absolute right-3 text-gray-500">₹</span>
              <input
                type="number"
                name="meter_cost"
                value={settings.meter_cost}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
            </div>
          </div>

          {/* Labour Cost */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Labour Cost</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <span className="absolute right-3 text-gray-500">₹</span>
              <input
                type="number"
                name="labour_cost"
                value={settings.labour_cost}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
            </div>
          </div>

          {/* Miscellaneous Charge */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Miscellaneous Charge</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <span className="absolute right-3 text-gray-500">₹</span>
              <input
                type="number"
                name="misc_charge"
                value={settings.misc_charge}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
            </div>
          </div>

          {/* GST Rate */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">GST Rate</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <input
                type="number"
                name="GST_rate"
                value={settings.GST_rate}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
              <span className="absolute right-3 text-gray-500">%</span>
            </div>
          </div>

          {/* Electricity Rate */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Electricity Rate (per unit)</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <span className="absolute right-3 text-gray-500">₹</span>
              <input
                type="number"
                name="electricity_rate"
                value={settings.electricity_rate}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
            </div>
          </div>

          {/* Expected Units */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">Expected Units per KWp/Day</label>
            <div className="relative flex items-center bg-gray-50 rounded-lg border border-gray-200 transition-colors hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200">
              <input
                type="number"
                name="expected_units_per_kwp_per_day"
                value={settings.expected_units_per_kwp_per_day}
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                className="w-full px-4 py-3 bg-transparent border-0 focus:ring-0 text-gray-700"
              />
              <span className="absolute right-3 text-gray-500">units</span>
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
        >
          <FiSave className="w-5 h-5" />
          Save Changes
        </button>
      </form>
    </div>
  );
};

export default QuotationSettings;